













































import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import SelectOption from "@/common/ui/presenters/select-option";
import { SearchProjectCalendarQuery } from "@/api/project/project-calendar-api";
import { statusSearchDashboard } from "@/status";

@Component({})
export default class ProjectCalendarSearchBar extends Vue {
  @Prop({ default: () => {} }) defaultQuery!: SearchProjectCalendarQuery;
  @Prop({ default: () => [] }) staffOptions!: SelectOption[];
  @Prop({ default: () => [] }) companyOptions!: SelectOption[];
  @Prop({ default: () => [] }) roleOptions!: SelectOption[];
  @Prop({ default: () => [] }) companyList!: SelectOption[];

  query: SearchProjectCalendarQuery = {
    status: "",
    staff: "",
    company: "",
    role: "",
    companyList: ""
  };

  get statusOptions() {
    return [
      {
        text: "全ての現場",
        value: ""
      },
      ...statusSearchDashboard
    ];
  }

  @Watch("defaultQuery", { immediate: true })
  onDefaultQueryChanged() {
    this.query = { ...this.query, ...this.defaultQuery };
  }

  submit() {
    this.$emit("submit", this.query);
  }

  handleCompanyChange() {
    this.query.staff = "";
    this.submit();
  }
}
